const eaeControlsModule = angular.module("eaeControls", ["luegg.directives", "eaeInteraction"]);
export default eaeControlsModule;
